import { render, staticRenderFns } from "./moreTrainingCourse.vue?vue&type=template&id=bc03899c&scoped=true&"
import script from "./moreTrainingCourse.vue?vue&type=script&lang=js&"
export * from "./moreTrainingCourse.vue?vue&type=script&lang=js&"
import style0 from "./moreTrainingCourse.vue?vue&type=style&index=0&id=bc03899c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc03899c",
  null
  
)

export default component.exports